import React, { ForwardedRef, forwardRef, useEffect, useRef, useState } from 'react'
import { Fn } from 'depoto-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons'

export interface FormInputProps {
  className?: string
  inputclassName?: string
  isDisabled?: boolean
  placeholder?: string
  type?: 'text' | 'number' | 'password' | 'date'
  label?: string
  value?: string
  debounceMs?: number
  min?: number
  max?: number
  blurOnInit?: boolean
  onChange?: Fn
  onSubmit?: Fn
  onBlur?: Fn
  error?: string
}

// export const FormInput: React.FC<Props> = forwardRef<HTMLInputElement, Props>(({
export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  (
    {
      className,
      isDisabled,
      inputclassName,
      label,
      placeholder,
      type = 'text',
      children,
      value,
      debounceMs,
      min,
      max,
      blurOnInit,
      onChange,
      onSubmit,
      onBlur,
      error,
    },
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const [inputValue, setInputValue] = useState<string>(value || '')
    const inputRef = useRef<HTMLInputElement>(null)
    const [showPassword, setShowPassword] = useState(false)

    useEffect(() => {
      if (blurOnInit && inputRef?.current) {
        setTimeout(() => inputRef?.current?.blur(), 50) // fukin helllllllll!!!!!! wtf how is this even remotely logical????!?!??!
      }
    }, [])

    useEffect(() => {
      if (debounceMs) {
        const delayInputTimeoutId = setTimeout(() => {
          typeof onChange === 'function' ? onChange(inputValue) : null
        }, debounceMs)
        return () => clearTimeout(delayInputTimeoutId)
      }
    }, [inputValue, debounceMs])

    useEffect(() => {
      setInputValue(value || '')
    }, [value])

    return (
      <div
        className={className === undefined ? 'form-control' : className + ' form-control '}
        style={{ position: 'relative' }}>
        <label className={label === undefined ? 'none' : ''}>{label}</label>
        <input
          ref={inputRef}
          type={type === 'password' && showPassword ? 'text' : type}
          placeholder={placeholder === undefined ? '' : placeholder}
          className={inputclassName === undefined ? 'input' : inputclassName + ' input'}
          disabled={isDisabled}
          value={inputValue}
          min={min}
          max={max}
          onChange={ev => setInputValue(ev.target.value)}
          onKeyDown={ev => (ev.key === 'Enter' && typeof onSubmit === 'function' ? onSubmit() : null)}
          onBlur={ev => (typeof onBlur === 'function' ? onBlur(ev.target.value) : null)}
          style={type === 'password' ? { paddingRight: '2.5rem' } : {}}
        />
        {type === 'password' && (
          <button
            type="button"
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            onClick={() => setShowPassword(v => !v)}
            style={{
              position: 'absolute',
              right: '1.5rem',
              bottom: '0.7rem',
              // transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              zIndex: 2,
            }}
            tabIndex={-1}>
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </button>
        )}
        {!!error && <span className={'text-red-500'}>{error}</span>}
      </div>
    )
  },
)
